import http from '@/libs/axios'

export function getContracts(params) {
  return http({
    url: '/contract/contract/',
    method: 'GET',
    params,
  })
}

export function deleteContracts(id) {
  return http({
    url: `/contract/contract/${id}`,
    method: 'DELETE',
  })
}

export function createContracts(data) {
  return http({
    url: '/contract/contract/',
    method: 'POST',
    data,
  })
}

export function updateContracts(data) {
  return http({
    url: `/contract/contract/${data.id}`,
    method: 'PUT',
    data: data.data,
  })
}

export function updateContractsPatch(data) {
  return http({
    url: `/contract/contract/${data.id}`,
    method: 'PATCH',
    data: data.data,
  })
}

export function getOneContracts(id) {
  return http({
    url: `/contract/contract/${id}/`,
    method: 'GET',
  })
}



export function createContractInvoice(payload) {
  return http({
    url: '/contract/invoice/',
    method: 'POST',
    data: payload,
  })
}


export function updateContractInvoice(payload) {
  return http({
    url: `/contract/invoice/${payload.id}`,
    method: 'PUT',
    data: payload.data
  })
}

export function updatePatchContractInvoice(payload) {
  return http({
    url: `/contract/invoice/${payload.id}`,
    method: 'PATCH',
    data: payload.data
  })
}

export function deleteContractGoods(payload) {
  return http({
    url: `/contract/contract/${payload.id}/delete_good/`,
    method: 'DELETE',
  })
}

export function deleteContractInstruments(payload) {
  return http({
    url: `/contract/contract/${payload.id}/delete_instrument/`,
    method: 'DELETE',
  })
}

export function deleteRequirementGoods(payload) {
  return http({
    url: `/contract/contract/${payload.contract_id}/delete_requirement_good/`,
    method: 'DELETE',
    data: {
      requirement_good: payload.requirement_good_id
    }
  })
}

export function deleteRequirementInstruments(payload) {
  return http({
    url: `/contract/contract/${payload.id}/delete_requirement_instrument/`,
    method: 'DELETE',
  })
}